import { useDeleteDeposit } from '../../states/deposits-state'
import moment from 'moment'
import { ACLContainer } from '../acl-container/acl-container'
import { useContext } from 'react'
import { EditModeContext } from '../../utils/edit-mode-context'
import { NumericFormat } from 'react-number-format'

interface Props {
  readonly id: string
  readonly realizedAt: Date
  readonly amount: number
  readonly currencyCode: string
  readonly showId: boolean
  readonly accountName: string
}

export const DepositItem = (props: Props) => {
  const { id, currencyCode, realizedAt, amount, accountName } = props

  const deleteDeposit = useDeleteDeposit()
  const handleRemove = (): void => {
    void deleteDeposit(id)
  }

  return (
    <tr key={id}>
      <td>
        <NumericFormat
          className="font-bold"
          valueIsNumericString
          displayType="text"
          contentEditable={false}
          value={parseFloat(amount.toString()).toFixed(2)}
          thousandSeparator={' '}
          decimalScale={2}
          prefix={`CZK `}
        />
      </td>
      <td>
        <span
          className="badge badge-sm badge-info"
          title={moment(realizedAt).format('YYYY-MM-DD HH:mm')}>
          {moment(realizedAt).fromNow()}
        </span>
      </td>

      <ACLContainer onlyManagement isEditableOnly>
        <td>{accountName}</td>
        <td>
          <button className="btn btn-sm btn-warning" onClick={handleRemove}>
            Delete
          </button>
        </td>
      </ACLContainer>
    </tr>
  )
}